import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { isAxiosError } from "axios";
import { axiosInstance } from "./axiosApiInstance";
import { createLogger } from "@/debug/DebugingLogger";
import { showNotificationGlobal } from "stores/useNotificationStore";
import { checkCanConnect } from "components/canvas/utils/CanvasActions";
import { canvasExit } from "@/lib/navigation/canvasHome";

export const ProtectedCanvasRoute = ({ children }) => {
  const log = createLogger("ProtectedCanvasRoute");
  const { model_id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const client_id = String(localStorage.getItem("clientID"));
  const [canConnectModel, setCanConnectModel] = useState(false);
  const [connectionChecked, setConnectionChecked] = useState(false);
  useEffect(() => {
    const checkUserModelAccess = async () => {
      try {
        const response = await axiosInstance.post(
          `/action/check_access/${model_id}`,
        );
        if (response.status === 200) {
          setHasAccess(true);
        } else {
          log.error(
            "Access denied or unexpected status code:",
            response.status,
          );
        }
      } catch (error: unknown) {
        if (isAxiosError(error) && error.response) {
          log.error(
            "User doesn't have access to this model:",
            error.response.status,
          );
        } else {
          const message =
            error instanceof Error ? error.message : "Unknown error";
          log.error("Error checking access:", message);
        }
      } finally {
        setLoading(false);
      }
    };

    const canConnect = async () => {
      const canConnect = await checkCanConnect(client_id, String(model_id));
      setCanConnectModel(canConnect);
      setConnectionChecked(true);
    };
    checkUserModelAccess();
    canConnect();
  }, [model_id]);

  useEffect(() => {
    if (!loading && connectionChecked) {
      if (!hasAccess) {
        showNotificationGlobal("Model was not found!", "error");
        navigate(canvasExit(), { replace: true });
      } else if (!canConnectModel) {
        showNotificationGlobal(
          "This model is already active in a different tab or window!",
          "default",
        );
        navigate(canvasExit(), { replace: true });
      }
    }
  }, [loading, hasAccess, canConnectModel, connectionChecked, navigate]);

  if (loading || !connectionChecked) {
    return <div></div>;
  }

  if (!hasAccess || !canConnectModel) {
    return null;
  }

  return children;
};
